
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChartNationalLanguageProposal2 as ObiChartNationalLanguageProposal2Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-chart-national-language-proposal-2.js';
 
 
 

 
 export const ObiChartNationalLanguageProposal2 = createComponent({
   react: React,
   tagName: 'obi-chart-national-language-proposal-2',
   elementClass: ObiChartNationalLanguageProposal2Element,
   events: {
     
   }
  });
 
 